import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

function PrivateStateFullRoute({ children, keyName, logicHandler, ...rest }) {
	return (
		<Route
			{...rest}
			render={({ location }) => {
				const user = sessionStorage && sessionStorage.getItem('USER_DETAIL');
				const API_RESULT = sessionStorage && sessionStorage.getItem('CODE');
				if (logicHandler) {
					if (logicHandler(user, API_RESULT, location)) {
						return React.cloneElement(children, location);
					}
					return <Redirect to="/error" />;
				}
				if (user && keyName && API_RESULT === location.state[keyName]) {
					location.state = JSON.parse(user);
					return React.cloneElement(children, location);
				}
				return <Redirect to="/error" />;
			}}
		/>
	);
}
PrivateStateFullRoute.propTypes = {
	children: PropTypes.node.isRequired,
	keyName: PropTypes.string,
	logicHandler: PropTypes.func
};
export default PrivateStateFullRoute;
